import { Component, OnInit, signal, Signal } from '@angular/core';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { BaseReviewsComponent } from './base-reviews/base-reviews.component';

@Component({
    selector: 'app-c-reviews',
    imports: [
        SHeaderComponent,
        BaseReviewsComponent,
    ],
    templateUrl: './c-reviews.component.html',
    styleUrl: './c-reviews.component.scss'
})
export class CReviewsComponent extends CBaseComponent implements OnInit { 
  
  // public ctaButtonId!: Signal<Result<string, string>>;
  
  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader];
    this.groupLabels = [ElementsType.BaseReview];
    
    // this.ctaButtonId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId, 'cta-button');
    super.ngOnInit();
  }

}
